import { render, staticRenderFns } from "./BatteryPlus.vue?vue&type=template&id=13bffc4c&scoped=true"
import script from "./BatteryPlus.vue?vue&type=script&lang=js"
export * from "./BatteryPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bffc4c",
  null
  
)

export default component.exports